import { createAsyncThunk } from '@reduxjs/toolkit';
import { multipartUpload, selectApi } from '@socialive/common';

export default createAsyncThunk(
  'mediaUpload/uploadAsset',
  async ({ file, sessionHash, trigger }, { dispatch, getState }) => {
    const api = selectApi(getState());
    if (!api) throw new Error('API is required');

    const fileNameOverride = `${encodeURIComponent(sessionHash)}_0.${file.name.split('.').pop()}`;

    await dispatch(
      multipartUpload({
        file,
        fileNameOverride,
        bucket: 'recording-chunk',
        id: sessionHash,
        trigger,
        headers: { 'x-api-version': '2.0' }, // TODO: maybe try and use version 3.0
      })
    ).unwrap();

    await api(`/recording/stitch/${sessionHash}`, { method: 'POST', data: {} });

    return { sessionHash };
  }
);
